import Vue from 'vue'
import Router from 'vue-router'
import Empty from "@/views/layout/curr.vue"

Vue.use(Router)

export default new Router({
  // mode:"history",
  routes: [{
      path: '/',
      component: () => import("@/views/index/index.vue"),
      children: [{
        path: '/',
        name: "online",
        component: () => import("@/views/index/online.vue"),
        meta: {
          title: '在线授权 - 极客授权系统'
        }
      }, {
        path: 'down',
        name: "down",
        component: () => import("@/views/index/down.vue"),
        meta: {
          title: '下载源码 - 极客授权系统'
        }
      }, {
        path: 'replace',
        name: "replace",
        component: () => import("@/views/index/replace.vue"),
        meta: {
          title: '更换授权 - 极客授权系统'
        }
      }, {
        path: 'query',
        name: "query",
        component: () => import("@/views/index/query.vue"),
        meta: {
          title: '查询授权 - 极客授权系统'
        }
      }, ]
    },
    {
      path: '/login',
      component: () => import("@/views/account/login.vue"),
      meta: {
        title: '登录 - 极客授权系统'
      }
    },

    {
      path: '/admin',
      component: () => import("@/views/layout/index.vue"),
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('token')) {
          next()
        } else {
          next('/login')
        }
      },
      children: [{
          path: 'home',
          name: "home",
          component: () => import("@/views/home/home.vue"),
          meta: {
            title: '账户概况 - 极客短信'
          }
        },

        {
          path: 'project',
          name: "project",
          component: () => import("@/views/project/index.vue"),
          meta: {
            title: '项目管理 - 极客授权系统'
          }
        },{
          path: 'project/edit',
          name: "project",
          component: () => import("@/views/project/edit.vue"),
          meta: {
            title: '项目管理 - 极客授权系统'
          }
        }, {
          path: 'card',
          name: "card",
          component: () => import("@/views/card/index.vue"),
          meta: {
            title: '卡密管理 - 极客授权系统'
          }
        }, {
          path: 'auth',
          name: "auth",
          component: () => import("@/views/auth/index.vue"),
          meta: {
            title: '授权管理 - 极客授权系统'
          }
        }, {
          path: 'setting-user',
          name: "setting-user",
          component: () => import("@/views/setting/setting-user.vue"),
          meta: {
            title: '个人信息 - 极客授权系统'
          }
        }, {
          path: 'setting-log',
          name: "setting-log",
          component: () => import("@/views/setting/setting-log.vue"),
          meta: {
            title: '操作日志 - 极客授权系统'
          }
        }, {
          path: 'setting-replace',
          name: "setting-replace",
          component: () => import("@/views/setting/setting-replace.vue"),
          meta: {
            title: '更换记录 - 极客授权系统'
          }
        },




        {
          path: "*",
          redirect: '/'
        },
      ]
    },
    {
      path: "*",
      redirect: '/'
    },
  ]
})